export default "/_next/static/images/all-in-one-95e1fd2382c51ae896257b0f5aaefc79.svg";